export default {
  release: '16.7',
  date: 'December 2023',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-7-released/#this-months-notable-contributor',
  contributors: [
    {
      name: 'Muhammed Ali',
      gitlabUsername: 'ar-mali',
    },
    {
      name: 'Niklas van Schrick',
      gitlabUsername: 'Taucher2003',
    },
  ],
  writeUp: `As we continue to focus on growing our wider community, we are incredibly happy to see both MVPs nominated by members of [the Core team](https://about.gitlab.com/community/core-team/).

Muhammed was nominated for adding support for [specifying platform when using Docker images with GitLab Runner](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/112907).
This contribution took 9 months of collaboration and showed Muhammed's commitment and perseverance when a bug required a [follow-up](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/137100).
This solved a popular two-year-old [issue](https://gitlab.com/gitlab-org/gitlab-runner/-/issues/27919). "Great shoutout to the GitLab Runner team" Muhammed said, "for supporting me on bringing a long awaited feature to fruition".
Muhammed is an Automation Engineer at [Airtime Rewards](https://www.airtimerewards.co.uk/), working mainly with Terraform and promoting CI/CD and automation practices within the engineering teams.

Niklas was nominated for his continued contributions and support in many different forms.
Today marks exactly 1 year since [his last MVP award](/releases/2022/12/22/gitlab-15-7-released/#mvp).
Niklas tackles daunting work which proves challenging even for GitLab team members and plays a huge part in maintaining our wider community contributors.
Read more in the [nomination issue](https://gitlab.com/gitlab-com/www-gitlab-com/-/issues/34762#note_1681021745).

Thank you Muhammed and Niklas! 🙌`,
};
